import * as _ from 'lodash';
import { HGroup } from "../area/HGroup";
import { HLine } from "../area/HLine";
import { Global } from "../utilities/global";
import { Sol50 } from "./Sol50";


/* HProfil optimize and find AbschBlend
		Condition: first parameter is sorted by l (left)
	*/
export function HProfile_optimize(aRow: any[]): void {
	var i: number, j: number;
	var hprofileTmp: HLine;
	var hprofileCur: HLine;
	var abschblendTmp: HLine;
	var nXDif: number;
	var nXTol: number;
	nXTol = Sol50.nHorizontalAbstand + Global.nModAbstTol;
	hprofileTmp = new HLine(aRow[0]);
	hprofileCur = new HLine(null);
	hprofileCur.l = hprofileTmp.l;
	hprofileCur.r = hprofileTmp.r;
	hprofileCur.y = hprofileTmp.y;
	hprofileCur.e = 0;
	Global.aHProfile.push(hprofileCur);
	for (i = 1; i < aRow.length; i++) {
		hprofileTmp = aRow[i];
		if (hprofileTmp.l <= hprofileCur.r + nXTol) {
			if (hprofileTmp.r > hprofileCur.r) {
				nXDif = hprofileCur.r - hprofileTmp.l;
				if (nXDif > Global.nModAbstTol) {
					hprofileCur.e += nXDif;
				}
				hprofileCur.r = hprofileTmp.r;
			} else {
				nXDif = hprofileTmp.r - hprofileTmp.l;
				if (nXDif > Global.nModAbstTol) {
					hprofileCur.e += nXDif;
				}
			}
			//find AbschBlend
		} else {
			//next one
			hprofileCur = new HLine(null);
			hprofileCur.l = hprofileTmp.l;
			hprofileCur.r = hprofileTmp.r;
			hprofileCur.y = hprofileTmp.y;
			hprofileCur.e = 0;
			Global.aHProfile.push(hprofileCur);
		}
	}
}
//get hprofiles in a row
export function HProfile_getRow(aTmp: any[], iLen: number, iStart: number): any[] {
	var hprofilTmp: HLine;
	var hprofilTmp2: HLine;
	var aResult: any[];
	var i: number, j: number;
	var nYDif: number;
	if (iLen <= iStart) {
		return null!;
	}
	hprofilTmp = aTmp[iStart];
	j = 1;
	for (i = iStart + 1; i < iLen; i++) {
		hprofilTmp2 = aTmp[i];
		nYDif = hprofilTmp2.y - hprofilTmp.y;
		if (nYDif < Global.nModAbstTol && nYDif > -Global.nModAbstTol) {
			j++;
			//valid
		} else {
			break;
		}
	}
	aResult = new Array(j);
	for (i = 0; i < j; i++) {
		aResult[i] = aTmp[i + iStart];
	}
	return aResult;
}

export function HProfile_find(): number {
	var i: number, j: number;
	var hgroupTmp: HGroup;
	var iResult: number = 0;
	var iLen: number;
	var hprofileTmp: HLine;
	var iCurrent: number;
	var aRow: any[];
	var nHalf: number;
	var aTmp: any[];
	iLen = Global.hgroups.length;
	nHalf = Sol50.nVertikalAbstand / 2;
	Global.aHProfile = new Array();
	aTmp = new Array();
	//einfach alle HGroups als einzelne betrachten
	const temp = { l: 0, r: 0, y: 0 };
	for (i = 0; i < iLen; i++) {
		hgroupTmp = new HGroup(Global.hgroups[i]);
		//oben
		let hprofileTmp = temp;
		hprofileTmp.l = hgroupTmp.x;
		hprofileTmp.r = hgroupTmp.x + hgroupTmp.width;
		hprofileTmp.y = hgroupTmp.y - nHalf;
		aTmp.push({ ...hprofileTmp });
		//unten
		hprofileTmp = temp;
		hprofileTmp.l = hgroupTmp.x;
		hprofileTmp.r = hgroupTmp.x + hgroupTmp.width;
		hprofileTmp.y = hgroupTmp.height + hgroupTmp.y + nHalf;
		aTmp.push({ ...hprofileTmp });
	}
	//sort by y
	aTmp = _.sortBy(aTmp, 'y');
	iLen = aTmp.length;
	iCurrent = 0;
	while (iCurrent < iLen) {
		aRow = HProfile_getRow(aTmp, iLen, iCurrent);
		iCurrent += aRow.length;
		aRow = _.sortBy(aRow, 'l');
		HProfile_optimize(aRow);
	}
	return iResult;
}
